import React from "react";
import {
  convertFromUTCDate,
  convertUTCDateLocal,
} from "../../../../../../../utils/convertionFunc";

function CarePlanDailyTasksTable({ data }) {
  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "w-full"
          } rounded-lg flex justify-center`}
        >
          <table className="w-full overflow-scroll relative">
            <thead className="border rounded-lg">
              <tr>
                <th>Task</th>
                <th>Performed?</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Entered On</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={item.key || idx}>
                  <tr className="border-b">
                    <td>
                      {item.taskName?.trim() ? item.taskName : item.taskCode}
                    </td>
                    <td>{item.taskTaken === "Y" ? "Yes" : "No"}</td>
                    <td>{item.startCreatedTime}</td>
                    <td>{item.endCreatedTime}</td>
                    <td>{convertUTCDateLocal(item.enteredOn)}</td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CarePlanDailyTasksTable;
